<script>
  import { windows, restoreWindow } from '../os/windows.svelte.js';
  import { appById } from '../os/apps.js';
  import Icon from './Icon.svelte';

  // Command+Tab is canonical; Alt+Tab remains available outside macOS.
  let show = $state(false);
  let activeIndex = $state(0);
  let modifier = $state(null);

  // Group open windows by app
  const openApps = $derived.by(() => {
    const apps = new Map();
    windows.forEach(w => {
      if (!apps.has(w.appId)) {
        apps.set(w.appId, { ...appById(w.appId), windowId: w.id });
      }
    });
    return Array.from(apps.values());
  });

  export function handleKeyDown(e) {
    if ((e.metaKey || e.altKey) && e.key === 'Tab' && openApps.length) {
      e.preventDefault();
      if (!show) {
        show = true;
        modifier = e.metaKey ? 'Meta' : 'Alt';
        activeIndex = openApps.length > 1 ? 1 : 0;
      } else {
        activeIndex = e.shiftKey
          ? (activeIndex - 1 + openApps.length) % openApps.length
          : (activeIndex + 1) % openApps.length;
      }
    }
  }

  export function handleKeyUp(e) {
    if (e.key === modifier) {
      if (show) {
        show = false;
        const target = openApps[activeIndex];
        if (target) {
          restoreWindow(target.windowId);
        }
      }
      modifier = null;
    }
  }
</script>

<svelte:window onkeydown={handleKeyDown} onkeyup={handleKeyUp} />

{#if show && openApps.length > 0}
  <div class="app-switcher-overlay">
    <div class="app-switcher">
      <div class="apps-list">
        {#each openApps as app, i}
          <div class="app-item" class:active={i === activeIndex}>
            <Icon name={app.icon} size={64} />
            <span class="app-label" style:opacity={i === activeIndex ? 1 : 0}>{app.label}</span>
          </div>
        {/each}
      </div>
    </div>
  </div>
{/if}

<style>
  .app-switcher-overlay {
    position: fixed;
    inset: 0;
    z-index: 99999999;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
  }
  .app-switcher {
    background:
      repeating-linear-gradient(0deg, rgba(255,255,255,.035) 0 1px, rgba(0,0,0,.06) 1px 2px),
      linear-gradient(#646b6b, #303535);
    border: 1px solid #111;
    border-radius: 7px;
    padding: 18px 20px 24px;
    box-shadow: inset 0 1px rgba(255,255,255,.28), 0 12px 34px rgba(0,0,0,.68);
  }
  .apps-list {
    display: flex;
    gap: 16px;
    align-items: flex-end;
    height: 120px;
  }
  .app-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    gap: 12px;
    width: 80px;
    height: 100%;
    padding: 8px;
    border-radius: 5px;
    transition: background 0.1s, transform 0.1s;
  }
  .app-item.active {
    background: linear-gradient(#929999, #5b6262);
    box-shadow: inset 0 1px rgba(255,255,255,.3), 0 0 0 1px rgba(0,0,0,.55);
    transform: translateY(-2px);
  }
  .app-label {
    position: absolute;
    bottom: -32px;
    font: 14px var(--font);
    font-weight: 500;
    color: white;
    white-space: nowrap;
    text-shadow: 0 1px 2px rgba(0,0,0,0.8);
    transition: opacity 0.1s;
  }
</style>
